import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";

/** Slot name → the id NavBar renders for it. */
const SLOT_IDS = {
  breadcrumb: "nav-bar-breadcrumb-slot",
  action: "nav-bar-action-slot",
};

const NavBarPortal = ({ children, slot, fallbackToInline }) => {
  const [target, setTarget] = useState(null);
  const [resolved, setResolved] = useState(false);

  useEffect(() => {
    setTarget(document.getElementById(SLOT_IDS[slot]));
    setResolved(true);
  }, [slot]);

  if (target) return createPortal(children, target);

  if (resolved && fallbackToInline) return <>{children}</>;

  return null;
};

NavBarPortal.propTypes = {
  children: PropTypes.node,
  slot: PropTypes.oneOf(["breadcrumb", "action"]),
  fallbackToInline: PropTypes.bool,
};

NavBarPortal.defaultProps = {
  slot: "breadcrumb",
  fallbackToInline: false,
};

export default NavBarPortal;
